/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import networkList from "../../../constants/networkList";
import postService from "../../../services/httpService";
import CheckboxLayer from "../CheckboxLayer";
const $ = require("jquery");
class Btable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      tbody: [],
      rid: null,
      tbodydata: [],
    };
  }
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    this.setState((state) => ({ rid: rid }));
    this.fetchData(rid);
    $(".financial-table").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()) -
        190,
    });
  }

  getSnapshotBeforeUpdate(prevProps) {
    return prevProps;
  }

  componentDidUpdate(prevProps, snapshot) {
    const { slug } = this.props.match.params;

    if (snapshot !== null) {
      if (prevProps.location.search !== this.props.location.search) {
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get("rid");
        this.setState((state) => ({ rid: rid }));
        this.fetchData(rid);
      }
    }
  }

  componentWillUnmount() {
    this.setState((state) => ({
      date: new Date(),
      tbody: [],
      rid: null,
      tbodydata: [],
    }));
  }

  fetchData(rid) {
    const { name } = this.props.feild;
    const { getMasterPages, viewRolePermissions } = networkList;
    if (name === "rolePageTable") {
      postService(getMasterPages, "GET", "null").then((res) => {
        if (res.status) {
          this.setState(
            (state) => ({ tbody: res.data }),
            () => {
          
              if (rid !== null) {
                postService(viewRolePermissions, "POST", {
                  data: { roleid: rid },
                }).then((resp) => {
                  if (resp.status) {
                    let tbosydata = res.data;

                    tbosydata.map((row, key) => {
                      if (row.submenu.length === 0) {
                        Object.keys(row.permissions).map((perm, pkey) => {
                          resp.data.map((tdata, tkey) => {
                            if (tdata.submenu.length === 0) {
                              if (tdata["route"] === row["route"]) {
                                if (
                                  (tdata.permissions[perm] === "true" ||
                                    tdata.permissions[perm] === "false") &&
                                  row["permissions"][perm] === "1"
                                ) {
                                  tbosydata[key]["permissions"][perm] =
                                    JSON.parse(tdata.permissions[perm]);
                                }
                              }
                            }
                          });
                        });
                      }
                      if (row.submenu.length !== 0) {
                        row.submenu.map((smenu, skey) => {
                          Object.keys(smenu.permissions).map((sprem, spkey) => {
                            resp.data.map((tdata, tkey) => {
                              if (tdata.submenu.length !== 0) {
                                tdata.submenu.map((tsmen, tskey) => {
                                  if (tsmen["route"] === smenu["route"]) {
                                    if (
                                      (tsmen.permissions[sprem] === "true" ||
                                        tsmen.permissions[sprem] === "false") &&
                                      smenu.permissions[sprem] === "1"
                                    ) {
                                      if (
                                        tbosydata[key]["submenu"][skey] !==
                                        undefined
                                      ) {
                                        tbosydata[key]["submenu"][skey][
                                          "permissions"
                                        ][sprem] = JSON.parse(
                                          tsmen.permissions[sprem]
                                        );
                                      }
                                    }
                                  }
                                });
                              }
                            });
                          });
                        });
                      }
                    });

                
                    this.setState((state) => ({ tbodydata: resp.data }));
                    this.props.permissionsTablechange(tbosydata);

                    //this.props.editFeilds(res);
                  }
                });
              }
            }
          );
        }
      });
      // if (rid !== null) {
      //     postService(viewRolePermissions, 'POST', { data: { roleid: rid } }).then(res => {
      //         if (res.status) {
      //             let tbody = this.state.tbody;

      //             console.log(tbody);

      //             this.setState((state) => ({ tbodydata: resp.data }));
      //             //this.props.editFeilds(res);
      //         }
      //     });
      // }
    }
  }

  onselectChanges(evnt) {
    let tbody = this.state.tbody;
    let tbodydata = this.state.tbodydata;
    this.state.tbody.map((row, key) => {
      if (row.submenu.length === 0) {
        if (row["id"] === evnt["parrentMode"]) {
          tbody[key]["permissions"][evnt["id"]] = evnt["value"];
        }
      }
      if (row.submenu.length !== 0) {
        row.submenu.map((smen, skey) => {
          if (smen["id"] === evnt["parrentMode"]) {
            tbody[key]["submenu"][skey]["permissions"][evnt["id"]] =
              evnt["value"];
          }
        });
      }
    });

    tbodydata.map((row, key) => {
      if (row.submenu.length === 0) {
        if (row["id"] === evnt["parrentMode"]) {
          tbodydata[key]["permissions"][evnt["id"]] = evnt["value"];
        }
      }
      if (row.submenu.length !== 0) {
        row.submenu.map((smen, skey) => {
          if (smen["id"] === evnt["parrentMode"]) {
            tbodydata[key]["submenu"][skey]["permissions"][evnt["id"]] =
              evnt["value"];
          }
        });
      }
    });
    this.setState((state) => ({ tbodydata: tbodydata }));
    this.props.permissionsTablechange(tbody);
  }

  renderTbody() {}

  render() {
    const { slug } = this.props.match.params;
    const { colums } = this.props.feild;
    const { tbody, tbodydata } = this.state;
    return (
      <div className="financial-table table-responsive">
        <table class="table table-hover table-borderless role_table">
          <thead>
            <tr>
              {colums.map((cdata, ckey) => {
                return (
                  <th scope="col" key={ckey}>
                    {cdata.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {tbody.map((row, key) => {
              if (row.submenu.length === 0) {
             
                return (
                  <tr key={key}>
                    <th scope="row">{row.text}</th>
                    {Object.keys(row.permissions).map((perm, pkey) => {
                      if (
                        row.permissions[perm] === "1" ||
                        row.permissions[perm] === true ||
                        row.permissions[perm] === false
                      ) {
                        var pdata = {};
                        pdata["value"] = false;
                        pdata["name"] = perm;
                        pdata["disable"] = false;
                        pdata["parrentMode"] = row.id;
                        pdata["parrentName"] = row.text;
                        if (tbodydata.length !== 0) {
                          tbodydata.map((tdata, key) => {
                            if (tdata["route"] === row["route"]) {
                              if (slug !== "view_role") {
                                pdata["value"] = JSON.parse(
                                  tdata.permissions[perm]
                                );
                              } else {
                                if (JSON.parse(tdata.permissions[perm])) {
                                  pdata["value"] = JSON.parse(
                                    tdata.permissions[perm]
                                  );
                                  // this.onselectChanges(({ id: tdata.permissions[perm], value: JSON.parse(tdata.permissions[perm]), parrentMode: row.id, parrentName: row.text }))
                                } else {
                                  pdata["value"] = JSON.parse(
                                    tdata.permissions[perm]
                                  );
                                  pdata["disable"] = true;
                                }
                              }
                            }
                          });
                        } else {
                        
                          if (row.permissions[perm] === true) {
                            pdata["value"] = true;
                          }
                        }

                        return (
                          <td key={pkey}>
                            <CheckboxLayer
                              selectdata={pdata}
                              {...this.props}
                              onselectChanges={this.onselectChanges.bind(this)}
                              {...this.state}
                            />
                          </td>
                        );
                      } else {
                        var pdata = {};
                        pdata["value"] = false;
                        pdata["name"] = perm;
                        pdata["disable"] = true;
                        pdata["parrentMode"] = row.id;
                        pdata["parrentName"] = row.text;
                        return (
                          <td key={pkey}>
                            <CheckboxLayer
                              selectdata={pdata}
                              {...this.props}
                              onselectChanges={this.onselectChanges.bind(this)}
                              {...this.state}
                            />
                          </td>
                        );
                      }
                    })}
                  </tr>
                );
              }
              if (row.submenu.length !== 0) {
                return (
                  <React.Fragment>
                    <tr key={key}>
                      <th colspan={colums.length}>{row.text}</th>
                    </tr>

                    {row.submenu.map((smenu, skey) => {
                      return (
                        <tr key={skey}>
                          <td scope="row" className="pl-5">
                            {smenu.text}
                          </td>
                          {Object.keys(smenu.permissions).map((sprem, skey) => {
                            if (
                              smenu.permissions[sprem] === "1" ||
                              smenu.permissions[sprem] === true ||
                              smenu.permissions[sprem] === false
                            ) {
                              var pdata = {};
                              pdata["value"] = false;
                              pdata["name"] = sprem;
                              pdata["disable"] = false;
                              pdata["parrentMode"] = smenu.id;
                              pdata["parrentName"] = smenu.text;

                              if (tbodydata.length !== 0) {
                                tbodydata.map((tdata, key) => {
                                  if (tdata.submenu.length !== 0) {
                                    tdata.submenu.map((slmenu) => {
                                      if (slmenu["route"] === smenu["route"]) {
                                        if (slug !== "view_role") {
                                          pdata["value"] = JSON.parse(
                                            slmenu.permissions[sprem]
                                          );
                                          // this.onselectChanges(({ id: slmenu.permissions[sprem], value: JSON.parse(slmenu.permissions[sprem]), parrentMode: smenu.id, parrentName: smenu.text }))
                                        } else {
                                          if (
                                            JSON.parse(
                                              slmenu.permissions[sprem]
                                            )
                                          ) {
                                            pdata["value"] = JSON.parse(
                                              slmenu.permissions[sprem]
                                            );
                                          } else {
                                            pdata["value"] = JSON.parse(
                                              slmenu.permissions[sprem]
                                            );
                                            pdata["disable"] = true;
                                          }
                                        }
                                        {
                                          /* pdata['value'] =  JSON.parse(slmenu.permissions[sprem]); */
                                        }
                                      }
                                    });
                                  }
                                });
                              } else {
                                if (smenu.permissions[sprem] === true) {
                                  pdata["value"] = true;
                                }
                              }

                              return (
                                <td key={skey}>
                                  <CheckboxLayer
                                    selectdata={pdata}
                                    {...this.props}
                                    onselectChanges={this.onselectChanges.bind(
                                      this
                                    )}
                                    {...this.state}
                                  />
                                </td>
                              );
                            } else {
                              var pdata = {};
                              pdata["value"] = false;
                              pdata["name"] = sprem;
                              pdata["disable"] = true;
                              pdata["parrentMode"] = smenu.id;
                              pdata["parrentName"] = smenu.text;
                              return (
                                <td key={skey}>
                                  <CheckboxLayer
                                    selectdata={pdata}
                                    {...this.props}
                                    onselectChanges={this.onselectChanges.bind(
                                      this
                                    )}
                                    {...this.state}
                                  />
                                </td>
                              );
                            }
                          })}
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Btable;
